module.exports = __webpack_public_path__ + "img/Structures-Inspect-Large.10280d20.png";